var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI9Advantage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 64 64",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#79af43",
    height: 53.21,
    rx: 7.14,
    width: 53.21,
    x: 5.94,
    y: 5.34
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.68 24.75h7.8v29.99h-7.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 14.78,
    r: 4.77
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8 24.92C55.8 16.69 48.73 10 40 10s-15.77 6.67-15.77 14.9a14.712 14.712 0 005.85 11.8c2.54 1.93 6.92 2.58 10.53 2.6l-9.95 15.44h9.74s12-18.9 13.79-22.11v-.09a14.765 14.765 0 001.61-7.62zM40 32.72a7.8 7.8 0 117.8-7.8 7.8 7.8 0 01-7.8 7.8z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjY0IiB2aWV3Qm94PSIwIDAgNjQgNjQiIHdpZHRoPSI2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCBmaWxsPSIjNzlhZjQzIiBoZWlnaHQ9IjUzLjIxIiByeD0iNy4xNCIgd2lkdGg9IjUzLjIxIiB4PSI1Ljk0IiB5PSI1LjM0Ii8+PGcgZmlsbD0iI2ZmZiI+PHBhdGggZD0ibTExLjY4IDI0Ljc1aDcuOHYyOS45OWgtNy44eiIvPjxjaXJjbGUgY3g9IjE1LjUiIGN5PSIxNC43OCIgcj0iNC43NyIvPjxwYXRoIGQ9Im01NS44IDI0LjkyYzAtOC4yMy03LjA3LTE0LjkyLTE1LjgtMTQuOTJzLTE1Ljc3IDYuNjctMTUuNzcgMTQuOWExNC43MTIgMTQuNzEyIDAgMCAwIDUuODUgMTEuOGMyLjU0IDEuOTMgNi45MiAyLjU4IDEwLjUzIDIuNmwtOS45NSAxNS40NGg5Ljc0czEyLTE4LjkgMTMuNzktMjIuMTF2LS4wOWExNC43NjUgMTQuNzY1IDAgMCAwIDEuNjEtNy42MnptLTE1LjggNy44YTcuOCA3LjggMCAxIDEgNy44LTcuOCA3LjggNy44IDAgMCAxIC03LjggNy44eiIvPjwvZz48L3N2Zz4=";
export { SvgI9Advantage as ReactComponent };